"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReceivableResponseTapePreviewReportTypeIterable = exports.FundingRequestReportTypeIterable = exports.BorrowingBaseServicerReportTypeIterable = exports.ComplianceReportCfTypeIterable = exports.MetricKey = exports.ReceivableResponseTapePreviewJobs = exports.ManualBankAccountReportSource = exports.WEBHOOK_EVENT_TYPES = exports.ASSIGNMENT_WEBHOOK_EVENT_TYPES = exports.CreditFacilityType = exports.TellerEnrollmentStatus = exports.ArtifactTypeIterable = exports.GeneratedArtifactTypeIterable = exports.NON_SHADOWED_TABLES = exports.SANDBOX_ONLY_TABLES = exports.SHADOWED_TABLES = void 0;
// TODO(jon): these are currently sorted in the order they were added to the sandbox. Leaving them
//  this way for now for easy auditing, but once the sandbox stabilizes we should alphabetize.
/**
 * Tables present in both sandbox and live schemas. Definitions must match between schemas and will
 * be checked by the `schemaSync` script.
 */
exports.SHADOWED_TABLES = [
    'borrowing_base_pipeline_artifact_instances',
    'master_loan_tapes',
    'assigned_loan_tapes',
    'receivables',
    'receivable_events',
    'reports',
    'reports_to_entity_map',
    'cash_balances_feed_contexts',
    'cash_balances_feed_screenshots',
    'manual_bank_account_reports',
    'bank_account_reports',
    'cash_response_tapes',
    'borrowing_base_reports',
    'borrowing_base_report_attachments',
    'borrowing_base_report_loan_product_calculations',
    'funding_request_constraints',
    'eligibility_criteria_calculations',
    'concentration_limit_calculations',
    'accounting_accounts',
    'accounting_transactions',
    'accounting_entries',
    'events',
    'funding_request_verification_reports',
    'funding_request_approval_reports',
    'funding_requests',
    'funding_request_components',
    'proforma_funding_request_components_map',
    'credit_agreements',
    'credit_agreement_parties',
    'funding_request_receivable_eligibility_verification',
    'borrower_cash_balances_feed',
    'borrowing_base_pipeline_artifact_documents',
    'borrowing_base_pipeline_artifacts',
    'borrowing_base_pipeline_artifact_dependencies',
];
/** Tables present in sandbox but not in live. */
exports.SANDBOX_ONLY_TABLES = [];
/** Tables present in live but not in sandbox. */
exports.NON_SHADOWED_TABLES = [
    'assignment_strategies',
    'assignment_strategy_loan_product_criteria',
    'athena_queries',
    'bank_account_refreshes',
    'bank_accounts',
    'bank_institutions',
    'borrowing_base_servicer_reports',
    'compliance_reports_cf',
    'concentration_limit_multi_loan_product_calculations',
    'covenant_loan_tapes',
    'credit_facilities_v2_prep',
    'credit_facilities',
    'credit_facility_outstanding_balance_ledger_items',
    'credit_facility_state',
    'deliverable_tasks',
    'deliverables_artifacts_instances',
    'deliverables_artifacts',
    'deliverables_containers',
    'deliverables_containers_receipts',
    'deliverables_containers_receipts_actions_log',
    'funding_request_events',
    'funding_request_reports',
    'internal_repayment_tapes',
    'loan_products',
    'materialized_view_configuration',
    'metric_alert_state',
    'metric_alert_thresholds',
    'organizations',
    'plaid_asset_report_accounts',
    'plaid_asset_reports',
    'plaid_institution_accounts',
    'plaid_items',
    'receivable_documentation_generated',
    'receivable_documentation_raw',
    'receivable_documentation_verification_results',
    'receivable_response_tape_preview_attachments',
    'receivable_response_tape_preview_jobs',
    'receivable_response_tape_previews',
    'receivable_response_tape_preview_reports',
    'reporting_generate_worklease_status',
    'report_templates',
    'report_xlsx_template_properties',
    'teller_institution_accounts',
    'teller_item',
    'users',
    'webhook_attempts',
    'webhook_subscriptions',
    'valley_bank_van_cust',
    'valley_bank_van_dep_acct',
    'valley_bank_van_cust_acct_rel',
    'valley_bank_van_list',
    'valley_bank_van_product',
    'valley_bank_loan_cust_rel',
    'valley_bank_cuo_deposit',
    'valley_bank_cuo_collat',
    'valley_bank_collat_cust_rel',
    'valley_bank_ps_plus_portfolio',
    'valley_bank_ps_plus_account',
    'valley_bank_ps_plus_sec_detail',
    'valley_bank_ps_plus_sec_master',
    'valley_bank_van_cmmt',
    'valley_bank_van_loan_acct',
    'valley_bank_cuo_loan',
    'valley_bank_cuo_maint',
    'valley_bank_rrt',
    'valley_bank_portfolio_rrt',
    'valley_bank_assignment_queue',
    'valley_bank_assignment_event_log',
    'valley_bank_collateral_account_stats',
    'valley_bank_loan_account_stats',
    'receivable_borrowing_base_test_waivers',
];
exports.GeneratedArtifactTypeIterable = [
    'generatedCovenantLoanTape',
    'generatedLoanTape',
    'generatedCashBalanceFeed',
    'generatedRepaymentTape',
    'generatedSupplementalTape',
    'generatedFinancialData',
];
exports.ArtifactTypeIterable = [
    ...exports.GeneratedArtifactTypeIterable,
    'rawLoanTape',
    'rawCashBalanceFeed',
    'rawRepaymentTape',
    'rawSupplementalTape',
    'configTape',
    'rawReceivableDocumentation',
    'intermediateTape',
    'internalRepaymentTape',
    'cashResponseTape',
    'cashBalancesFeedContext',
    'masterLoanTape',
    'manualBankAccountReport',
    'assignedLoanTape',
    'receivableResponseTapePreview',
    'receivableResponseTape',
    'borrowingBaseReport',
    'receivableInvoice',
    'fundingVerificationReport',
    'fundingApprovalReport',
    'fundingRequest',
    'receivableDocumentationVerificationReport',
    'forwardedTape',
    'valleyBankIngest',
    'orgProvidedInput',
];
var TellerEnrollmentStatus;
(function (TellerEnrollmentStatus) {
    TellerEnrollmentStatus["Connected"] = "connected";
    TellerEnrollmentStatus["Disconnected"] = "disconnected";
    TellerEnrollmentStatus["AccountLocked"] = "accountLocked";
    TellerEnrollmentStatus["Inactive"] = "inactive";
    TellerEnrollmentStatus["CredentialsInvalid"] = "credentialsInvalid";
    TellerEnrollmentStatus["CaptchaRequired"] = "captchaRequired";
    TellerEnrollmentStatus["MfaRequired"] = "mfaRequired";
    TellerEnrollmentStatus["WebLoginRequired"] = "webLoginRequired";
})(TellerEnrollmentStatus = exports.TellerEnrollmentStatus || (exports.TellerEnrollmentStatus = {}));
var CreditFacilityType;
(function (CreditFacilityType) {
    CreditFacilityType["Warehouse"] = "warehouse";
    CreditFacilityType["VentureDebt"] = "ventureDebt";
})(CreditFacilityType = exports.CreditFacilityType || (exports.CreditFacilityType = {}));
exports.ASSIGNMENT_WEBHOOK_EVENT_TYPES = ['assignment.assign'];
exports.WEBHOOK_EVENT_TYPES = [
    ...exports.ASSIGNMENT_WEBHOOK_EVENT_TYPES,
    'fundingRequest.approved',
    'borrowingBaseReport.generated',
];
var ManualBankAccountReportSource;
(function (ManualBankAccountReportSource) {
    ManualBankAccountReportSource["AdminDashboard"] = "adminDashboard";
    ManualBankAccountReportSource["BorrowerDashboard"] = "borrowerDashboard";
    ManualBankAccountReportSource["BorrowerS3Upload"] = "borrowerS3Upload";
})(ManualBankAccountReportSource = exports.ManualBankAccountReportSource || (exports.ManualBankAccountReportSource = {}));
var ReceivableResponseTapePreviewJobs;
(function (ReceivableResponseTapePreviewJobs) {
    ReceivableResponseTapePreviewJobs.terminalStatuses = [
        'completed',
        'error',
    ];
    ReceivableResponseTapePreviewJobs.statuses = [
        'inProgress',
        ...ReceivableResponseTapePreviewJobs.terminalStatuses,
    ];
    ReceivableResponseTapePreviewJobs.assignmentMethod = ['csv', 'strategy', 'assignNone'];
})(ReceivableResponseTapePreviewJobs = exports.ReceivableResponseTapePreviewJobs || (exports.ReceivableResponseTapePreviewJobs = {}));
var MetricKey;
(function (MetricKey) {
    MetricKey["collateralCovenantLtv"] = "collateralCovenantLtv";
})(MetricKey = exports.MetricKey || (exports.MetricKey = {}));
// At the moment, this would generally align with "ReportConfigTypeIterable" in
// "CreditAgreement.DomainEntity", potentially being a subset of it.
exports.ComplianceReportCfTypeIterable = [
    'monthlyServicerReport',
];
exports.BorrowingBaseServicerReportTypeIterable = [
    'borrowingBaseServicerReport',
];
exports.FundingRequestReportTypeIterable = [
    'fundingRequestServicerReport',
];
exports.ReceivableResponseTapePreviewReportTypeIterable = [
    'receivableResponseTapePreviewServicerReport',
];
//# sourceMappingURL=DbTables.js.map